export enum ActivityStatusEnum {
  ACTIONED = 'Actioned',
  UNACTIONED = 'Unactioned',
}
